import { perfilMarca } from '@aosenuma/lib-types';

// URL del reporte público de cierre (Cloudflare Pages, sin login). Apunta directo al
// dominio pages.dev (activo hoy); cuando el subdominio elawan-reporte.aosenumareport.com
// tenga su CNAME, basta con setear VITE_PUBLIC_URL_REPORTE para migrarlo.
const URL_REPORTE =
  import.meta.env.VITE_PUBLIC_URL_REPORTE ?? 'https://elawan-reporte.pages.dev';

export function TopNav() {
  const marca = perfilMarca();
  return (
    <nav className="topnav">
      <span className="pill-status">
        <span className="dot" />
        <span>SIG en vivo</span>
      </span>
      <a href="#proyecto">Proyecto</a>
      <a href="#metodologia">Metodología</a>
      <a href="#contacto">Contacto</a>
      {/* En modo presentación el CTA sigue ahí, pero enmascarado: el host lleva
          el nombre del cliente y se lee al pasar el cursor. Cambia también el
          destino, no solo la cadena — detrás hay un reporte de cierre del
          cliente y un clic en la reunión lo abriría entero. */}
      <a
        className="nav-cta"
        href={marca.neutral ? 'https://aosenuma.com/' : URL_REPORTE}
        target="_blank"
        rel="noopener noreferrer"
      >
        Reporte
      </a>
    </nav>
  );
}
